const Background = () => {
  return (
    <svg
      viewBox="0 0 192.8287 147.6805"
      style={{
        width: "100%",
        height: "100vh",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: -1
      }}
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient
          id="grad"
          gradientUnits="userSpaceOnUse"
          x1="592.85028"
          y1="-168.39259"
          x2="-246.2524"
          y2="647.94391"
          gradientTransform="matrix(1,0,0,0.48929074,-2.399142,130.46485)"
        >
          <stop offset="0" stopColor="#EFC94E" />
          <stop offset="1" stopColor="#9E1CB9" />
        </linearGradient>
      </defs>

      <path
        width="192.8287"
        height="147.6805"
        x="61.241589"
        y="-620.72101"
        d="M 0.02016348,0.00513878 H 192.84887 V 147.68563 H 0.02016348 Z"
        style={{
          fill: "url(#grad)"
        }}
      />
      <path
        d="m -120.76643,133.89235 c -3.12835,-16.30808 19.63716,-29.93578 42.062312,-38.930419 17.762964,-7.12409 37.423439,-13.34485 58.627101,-14.02921 21.2036805,-0.68432 44.151,5.40639 52.89261,17.257059 4.53166,6.14546 4.89997,13.11671 4.54565,19.85757 -0.96508,18.43184 -6.37323,38.02481 7.29634,54.45606 13.78144,16.56586 43.9272,25.62666 73.504167,29.81716 44.78505,6.34622 92.75905,3.95556 135.28294,-6.74312 35.67045,-8.97413 69.84435,-26.12852 75.28979,-49.5105 4.93726,-21.20575 -18.25715,-43.55437 -51.70841,-49.816159 -20.3225,-3.80499 -42.52389,-2.0713 -62.58065,2.235549 -20.05677,4.30683 -38.42582,11.05225 -56.88812,17.49654 -7.40822,2.58686 -15.05888,5.17599 -23.48347,5.97211 -23.69328,2.23783 -44.533297,-10.2105 -55.428847,-23.29072 -13.38516,-16.070829 -18.42034,-34.354419 -31.62833,-50.484551 -7.92573,-9.68128 -18.66744,-18.42499 -26.36006,-28.177 -7.69262,-9.74973 -12.20563,-21.1327602 -6.65761,-31.41625 4.40576,-8.17116 14.68125,-14.71128 26.14092,-19.6865 18.05202,-7.840371 42.02503,-12.434681 62.464107,-7.235871 16.75127,4.261201 28.4021,15.128691 28.12703,26.233431 -0.46623,18.9200299 -30.48144,32.23749 -41.735987,49.85952 -7.44553,11.65903 -6.05152,25.311852 3.70644,36.311652 10.522597,11.86436 36.052767,20.49859 54.808777,13.39958 2.65746,-1.00599 5.10045,-2.32907 6.44316,-4.05591 2.81597,-3.62479 0.0653,-8.02516 -4.13536,-11.10701 -4.20064,-3.08185 -9.75331,-5.39722 -13.8747,-8.52016 -14.43416,-10.940492 -6.82545,-27.335242 4.68084,-39.507582 14.00057,-14.8070899 32.88247,-27.8781501 55.1771,-38.19135 15.80017,-7.31112 34.52354,-13.42922 54.30059,-12.78594 6.00956,0.19619 12.93758,1.52385 14.85374,5.01858 1.93015,3.5221 -2.31244,7.11498 -6.4991,9.80217 -24.36463,15.6328599 -57,27.00679 -73.82119,46.00435 -7.01661,7.92476 -10.48995,18.32691 -1.72035,25.567352 10.58783,8.74143 32.22509,8.00233 49.3167,5.02315 58.82292,-10.26071 109.21193,-37.317672 133.51129,-71.6948821 0.90446,-1.27744 1.78563,-2.6781 1.21217,-4.0239899 -0.4429,-1.03566 -1.68771,-1.86371 -2.90921,-2.63018 -26.06633,-16.34458 -61.77408,-26.112541 -98.46091,-30.261981 -36.68681,-4.14945 -74.47857,-3.00204 -111.44046,0.10271 -105.654677,8.876031 -207.593587,33.8821909 -294.04001,72.128281"
        style={{
          fill: "#ae3d56",
          fillOpacity: 0.157579,
          fillRule: "nonzero"
        }}
      />
    </svg>
  );
};

export default Background;
